import { apiFetch } from "../utils/apiFetch";

export async function getUniversalAccess() {
  const res = await apiFetch("/api/admin/settings/universal-access", {
    method: "GET",
  });
  const json = await res.json();
  return !!json.on;
}

export async function setUniversalAccess(on) {
  const res = await apiFetch("/api/admin/settings/universal-access", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ on: !!on }),
  });
  return !!res.on;
}

/* ------------------------------------------------------------------ */
/*  Armoire médicale                                                    */
/* ------------------------------------------------------------------ */

/** Config complète (admin) */
export async function getArmoireConfig() {
  const res = await apiFetch("/api/admin/settings/armoire", { method: "GET" });
  return res.json();
}

export async function setArmoireConfig(cfg) {
  const res = await apiFetch("/api/admin/settings/armoire", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(cfg),
  });
  return res.json();
}

/** Config publique (rôle courant : visible ou non) */
export async function getArmoirePublic() {
  const res = await apiFetch("/api/admin/settings/armoire/public", { method: "GET" });
  return res.json();
}

/** Déclencher l'ouverture (le back proxie vers HA) */
export async function triggerArmoire() {
  const res = await apiFetch("/api/admin/settings/armoire/trigger", { method: "POST" });
  const json = await res.json();
  if (!res.ok) throw new Error(json.error || "Erreur armoire");
  return json;
}
